import React, { useEffect, useState } from "react";
import TableContainer from "../../components/table/table-container";
import Button from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination/pagination";
import search from "../../assets/icons/searchIcon.svg";
import { useDispatch } from "react-redux";
import { errorToast, successToast } from "../../components/notifications/toast";
import Loader from "../../components/loaders/dot-loader";
import { enableDisableDroperAction, listDroperAction } from "../../redux/actions/droperAction";
import LoaderModal from "../../components/modals/loader-modal";
import { formatString } from "../../components/helper";

const Dropers = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [paginationData, setPaginationData] = useState(null);
    const [dropers, setDropers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false)

    const handlePageChange = (page) => {
        setCurrentPage(page);
        console.log("Current Page:", page);
    };

    const handleEdit = (id) => {
        navigate(`/dropers/edit/${id}`);
    };

    const handleEnableDisable = (id) => {
        setModalLoading(true)
        dispatch(enableDisableDroperAction({ id }, (data) => { successToast(data.data.message); fetchDropers(); setModalLoading(false) }, onError))
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchDropers()
    }, [currentPage, debouncedValue])

    const fetchDropers = () => {
        setLoading(true)
        dispatch(listDroperAction({ page: currentPage, search: debouncedValue }, onSuccess, onError))
    }


    const onSuccess = (data) => {
        setDropers(data.data.data.dropers);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
        setModalLoading(false)
    }

    return (
        <TableContainer>
            <div className="flex flex-col sm:flex-row justify-between px-2 pb-2 w-full">
                <div className="w-full sm:w-auto">
                    {/* Bread crumb data */}
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-80`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search here`}
                            className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e?.target?.value);
                            }}
                        />
                        <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchValue('')} >Clear</span>
                    </div>
                </div>

                <div className="w-full sm:w-auto mt-2 sm:mt-0">
                    <Button onClick={() => navigate('/dropers/create')} variant="primary" size="md" className="w-full sm:w-auto">
                        Create New
                    </Button>
                </div>
            </div>

            <div className="relative">
                <div className="overflow-auto border border-gray-300 rounded-md" style={{ height: '45rem' }}>
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100 sticky top-0">
                                <th className="p-2 border border-gray-200 font-medium text-left">#</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Code</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Image</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Name</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Email</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Mobile</th>
                                <th className="p-2 border border-gray-200 font-medium">Address</th>
                                <th className="p-2 border border-gray-200 font-medium">Access</th>
                                <th className="p-2 border border-gray-200 font-medium">Status</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" style={{ height: '40rem' }}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : dropers.length > 0 ? dropers.map((droper, index) => (
                                <tr key={droper.id} className="hover:bg-gray-50">
                                    <td className="p-1 border border-gray-200">{(currentPage - 1) * paginationData?.pageSize + (index + 1)}</td>
                                    <td className="p-1 border border-gray-200 text-left">{droper?.code}</td>
                                    <td className="p-1 border border-gray-200">
                                        {droper?.image ?
                                            <img
                                                src={droper?.image}
                                                alt={droper?.name}
                                                className="w-16 h-14 object-cover rounded-md truncate"
                                            />
                                            : <div className="py-2">--</div>
                                        }
                                    </td>
                                    <td className="p-1 border border-gray-200 text-left">{droper?.name}</td>
                                    <td className="p-1 border border-gray-200 text-left">{droper?.email}</td>
                                    <td className="p-1 border border-gray-200 text-left">{droper?.mobile}</td>
                                    <td className="p-1 border border-gray-200">{droper?.address}</td>
                                    <td className="p-1 border border-gray-200">{droper?.access.length > 0 ? droper?.access.map((item) => formatString(item)).join(', ') : "--"}</td>
                                    <td className={`p-1 border border-gray-200 ${droper?.status ? "text-green-600" : "text-red-600"}`}>{droper?.status ? "Active" : "Inactive"}</td>
                                    <td className="p-2 border border-gray-200 text-center">
                                        <button
                                            onClick={() => navigate(`/dropers/view/${droper?.id}`)}
                                            className="text-blue-500 hover:underline mx-2"
                                        >
                                            View
                                        </button>

                                        <button
                                            onClick={() => handleEdit(droper?.id)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() => handleEnableDisable(droper?.id)}
                                            className={`hover:underline mx-2 ${droper?.status ? "text-red-600" : "text-green-600"}`}
                                        >
                                            {droper?.status ? "Disable" : "Enable"}
                                        </button>
                                    </td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <span className="text-gray-400 font-extralight"> No Data Found</span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex justify-end mt-2 bottom-0 right-0">
                <Pagination
                    totalPages={paginationData?.totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </div>
            {modalLoading &&
                <LoaderModal />
            }
        </TableContainer>
    );
};

export default Dropers;
